import { Suspense } from 'react'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useUserPreferences } from '@/src/hooks/use-user-preference-port/useUserPreferencePort'
import { userPreferencesPort } from '@/infra/config/beans'
import { useNavigate, useOutletContext } from 'react-router-dom'
import VendorSummaryCard from '@/src/components/my-team/vendor-summary-card/VendorSummaryCard'
import FamilyCardListSkeleton from '@/src/components/global/family-card-list-skeleton/FamilyCardListSkeleton'
import { createSearchParams } from 'react-router'
import { getTeams } from '@/infra/api/generated/teams/teams'

const { getVendorSummaries } = getTeams()

const vendorSummariesQuery = (periodValue: string, storeId?: number, teamId?: number) => ({
  queryKey: ['diagnoses', 'vendors', 'summary', storeId, teamId, periodValue],
  queryFn: () =>
    getVendorSummaries(storeId!, teamId!, {
      periodValue: periodValue,
    }),
  enabled: Boolean(storeId) && Boolean(teamId),
})

export const Vendors = () => {
  return (
    <div className="flex flex-col gap-4">
      <Suspense fallback={<VendorsSkeleton />}>
        <VendorsContent />
      </Suspense>
    </div>
  )
}

const VendorsContent = () => {
  const { team, store } = useUserPreferences(userPreferencesPort)
  const { month } = useOutletContext<{ month: string }>()
  const { data: vendorDiagnosisSummaries } = useSuspenseQuery(
    vendorSummariesQuery(month, store?.id, team?.id)
  )

  const navigate = useNavigate()
  const onVendorCardClick = (userId: string) => {
    const params = month ? { periodValue: month } : undefined
    void navigate({
      pathname: `/my-team/${userId}/details`,
      search: createSearchParams(params).toString(),
    })
  }
  return (
    <div className="flex flex-col gap-3">
      {vendorDiagnosisSummaries.map((vendorDiag) => (
        <VendorSummaryCard
          key={vendorDiag.userId}
          userId={vendorDiag.userId}
          averageScore={vendorDiag.averageScore}
          countDiagnoses={vendorDiag.countDiagnoses}
          onClick={onVendorCardClick}
        />
      ))}
    </div>
  )
}

const VendorsSkeleton = () => {
  return <div className="flex flex-col gap-3">{<FamilyCardListSkeleton skeletonCount={3} />}</div>
}

export default Vendors
